module.exports = __webpack_public_path__ + "img/guideShareIcon.72ee5586.png";